import dayjs from "dayjs"
import { IconBanSmokingSolidFull, IconCatSolidFull, IconCopySolidFull, IconDogSolidFull, IconOpensuseBrandsSolidFull, IconPersonDressSolidFull, IconPersonSolidFull, IconPhoneSolidFull, IconSmokingSolidFull } from "../../../../icon"
import { Button, Popover } from "antd"
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { useCalculateCustomerBudgetQuery, useGetCommentsQuery, useGetInsuranceQuery } from "../../../../api/plamo-api";
import { CommentField } from "../../fragments/comments";

const CopyButtonStyled = styled(Button)`
  span.anticon {
    font-size: 24px !important;
  }
`

const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
const monthLabels = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

const BudgetTable: React.FC<any> = ({ customerId }: { customerId: number }) => {
  const { data: budget } = useCalculateCustomerBudgetQuery({ id: customerId, year: dayjs().year() }) as any;
  const [expanded, setExpanded] = useState<boolean>(false);

  const { minHours, minHoursNextMonth, recommendedHours, remainingHours, 
    supportAmountMax } = useMemo(() => {
    const monthShort:string = months[dayjs().month()]
    const nextMonthShort: string = months[(dayjs().month() + 1) % 12]
    const result: any = {
      remainingHours: budget?.maxHours || 0,
      supportAmountMax: (budget || {})[monthShort]?.supportAmount || 0, 
      supportAmountMaxNextMonth: (budget || {})[nextMonthShort]?.supportAmount || 0,
    }

    const workTime = (budget || {})[monthShort]?.workTime || 0;

    result.supportAmountMin = Math.min(Math.max(4 - workTime, 0), result.supportAmountMax);
    result.supportAmountMinNextMonth = Math.min(4, result.supportAmountMaxNextMonth);
    result.supportAmountRecommended = result.supportAmountMin;

    result.minHours = budget?.minHours || 0;
    result.minHoursNextMonth = Math.min(4, result.supportAmountMaxNextMonth);
    result.recommendedHours = result.supportAmountRecommended;

    return result;
  }, [budget])

  return (
    <table style={{ width: "100%" }}>
      <tr>
        <td rowSpan={3} style={{ textAlign: "center", minWidth: "2em" }} onClick={() => setExpanded(e => !e)}></td>
        <td style={{ textAlign: "center", backgroundColor: "#b4e5a2", padding: "0.5em" }}>Mind.</td>
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}>Empf.</td>
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}>Max.</td>
        <td style={{ textAlign: "center", backgroundColor: "#f2aa84", padding: "0.5em" }}>Verfall</td>
      </tr>
      { false && 
      <tr>
        <td style={{ textAlign: "center", backgroundColor: "#b4e5a2", padding: "0.5em" }}>{ monthLabels[dayjs().month()] }</td>
        <td style={{ textAlign: "center", backgroundColor: "#b4e5a2", padding: "0.5em" }}>{ monthLabels[dayjs().month() + 1 % 12] }</td>
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}></td>
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}></td>
        <td style={{ backgroundColor: "#f2aa84", padding: "0.5em" }}></td>
      </tr>
      }
      <tr>
        <td style={{ textAlign: "center", backgroundColor: "#b4e5a2", padding: "0.5em" }}>{ minHours }</td>
        { false && <td style={{ textAlign: "center", backgroundColor: "#b4e5a2", padding: "0.5em" }}>{ minHoursNextMonth }</td> }
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}>{ recommendedHours }</td>
        <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}>{ remainingHours }</td>
        <td style={{ backgroundColor: "#f2aa84", padding: "0.5em" }}></td>
      </tr>
      {
        expanded && <><tr>
          <td style={{ padding: "0.5em"}}>EB</td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}>{ supportAmountMax }</td>
          <td style={{ backgroundColor: "#f2aa84" }}></td>
        </tr>
        <tr>
          <td style={{ padding: "0.5em"}}>VHP</td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}></td>
          <td style={{ backgroundColor: "#f2aa84" }}></td>
        </tr>
        <tr>
          <td style={{ padding: "0.5em"}}>UMW</td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#d9d9d9" }}></td>
          <td style={{ textAlign: "center", backgroundColor: "#92d050", padding: "0.5em" }}></td>
          <td style={{ backgroundColor: "#f2aa84" }}></td>
        </tr>
        </>
      }
    </table>
  )
}

function CustomerDashboard({ customer, customerId }) {
  const [copyMainDataPopupOpen, setCopyMainDataPopupOpen] = useState<boolean>(false);
  const { data: comments } = useGetCommentsQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: "customer" }, objectId: { c: "EQ", v: customerId } }), st: JSON.stringify({ id: 'desc' }), c: 3 }) as any
  const { data: insurance } = useGetInsuranceQuery({ id: customer?.insuranceId }) as any;

  const copyMainData = useCallback(() => {
      const data = `${customer.firstName || ''} ${customer.lastName || ''}\n`
        + `${customer.addressStreet || ''} ${customer.addressHouseNumber || ''}\n`
        + `${customer.addressZipCode || ''} ${customer.addressCity || ''}\n`
        + `${customer.phone || ''}\n`
        + `${customer.mobile || ''}\n`
        + '\n'
        + `${customer.socialSecurityNumber || ''}\n`
        + `${insurance?.name || ''}\n`
  
      navigator.clipboard.writeText(data);
      setCopyMainDataPopupOpen(true);
      setTimeout(() => setCopyMainDataPopupOpen(false), 2000);
    }, [customer, insurance, setCopyMainDataPopupOpen])

  return <>{customer && 
    <div style={{ display: "flex", flexDirection: "row", height: '100%', overflow: 'auto' }}>
      <div style={{ flex: 1 }}></div>
        <div style={{ display: "flex", flexDirection: "row", width: '1200px', maxWidth: '1200px' }}>
          <div style={{ fontSize: '200%', flex: 1, borderRight: "1px solid black" }}>
            <div style={{ float: "left", fontSize: "300%" }}>
              { customer.salutation === 'M' ? <IconPersonSolidFull /> : <IconPersonDressSolidFull />}
            </div>
            <div>
              {customer.firstName} {customer.lastName} <span style={{ fontSize: '80%' }}>{customer.dateOfBirth ? '* ' + dayjs(customer.dateOfBirth).format('DD.MM.YYYY') : ''}</span> <Popover
                        content={<>Daten kopiert</>}
                        open={copyMainDataPopupOpen}
                      ><CopyButtonStyled icon={<IconCopySolidFull />} type="link" onClick={copyMainData}/></Popover><br/>
              {customer.addressStreet || ''} {customer.addressHouseNumber || ''}<br/>
              {customer.addressZipCode || ''} {customer.addressCity || ''}
            </div>
            <div>{customer.phone} <IconPhoneSolidFull /> {customer.mobile}</div>
            <hr />
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ width: '50%'}}>{ insurance?.name }</td><td style={{ width: '50%'}}>{ customer.socialSecurityNumber }</td>
              </tr>
              <tr>
                <td>Pflegegrad {customer.careGrade}</td><td></td>
              </tr>
              <tr>
                <td colSpan={2}><BudgetTable customerId={customerId} /></td>
              </tr>
            </table>
            
            <table style={{ width: '100%' }}>
              <tr>
                <td style={{ textAlign: "center" }}>Haustiere</td><td style={{ textAlign: "center" }}>Raucher</td><td style={{ textAlign: "center" }}>Status</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                { customer.pets === 'Hund' && <IconDogSolidFull /> }  
                { customer.pets === 'Katze' && <IconCatSolidFull /> }  
                { customer.pets === 'Sonstige' && <IconOpensuseBrandsSolidFull /> }
                </td>
                <td style={{ textAlign: "center" }}>
                  { customer.smoker === 'y' && <IconSmokingSolidFull /> }
                  { customer.smoker === 'n' && <IconBanSmokingSolidFull /> }
                </td>
                <td style={{ textAlign: "center" }}>{ customer.status}</td>
              </tr>
            </table>
          </div>
          <div style={{ flex: 1, padding: '1em', display: 'flex', flexDirection: 'column' }}>
            <div>
              <h2>Allgemein</h2>
             { comments?.items?.filter(c => c.type === 'Allgemein').map(c => <CommentField value={c} readOnly />)}
            </div>
            <div>
              <h2>Aktuelles</h2>
             { comments?.items?.filter(c => c.type !== 'Allgemein').map(c => <CommentField value={c} readOnly />)}
            </div>

          </div>
      </div>
      <div style={{ flex: 1 }}></div>
  </div>}
  </>
}

export default CustomerDashboard